import React, {Component} from 'react';
import axios from 'axios';
import NewsletterSignupForm from './NewsletterSignupForm'

export default class ModalNewsLetter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            emailSend: false,
            invalidEmailForm: false,
            consent: {
                id: null,
                text: `Vi bruger kun dine oplysninger til udsendelse af nyhedsbrevet, og
                    sletter dem, hvis du framelder dig, eller hvis vi ophører med at
                    udsende nyheder. Læs mere om, hvordan vi behandler dine oplysninger
                    <a class="kammer-link" href="http://kammeradvokaten.dk/om-os/saadan-haandterer-vi-dine-personoplysninger/" target="_blank">her</a>.`,
            },
            subscriptionIds: []
        };
    };

    componentDidMount = () => {
        var self = this;
        axios
            .get("/ajax/newsletter/getconsent")
            .then((response) => {
                if (response.data) {
                    self.setState({ consent: response.data });
                }
            })
            .catch((error) => {
                console.log(error);
            });

        axios
            .get("/ajax/newsletter/getnewsletters")
            .then((response) => {
                if (response.data) {
                    const ids = response.data.map((x) => x.id);
                    self.setState({ subscriptionIds: ids });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    signupSuccess = () => {
        this.setState({emailSend: true})
    };

    onInvalidEmailForm = () => {
        this.setState({invalidEmailForm: true});
    };

    onValidEmailForm = () => {
        this.setState({invalidEmailForm: false});
    };

    closeModal = () => {
        this.props.closeModal()
    };

    componentWillMount = () => {
        document.body.classList.add("noScroll");
        document.documentElement.classList.add('noScroll');

        $("html, body").animate({ scrollTop: 0 }, "slow");
    }

    componentWillUnmount = () => {
        document.body.classList.remove('noScroll');
        document.documentElement.classList.remove('noScroll');
    };

    render() {
        return (
            <div className="share-popup">
                <div className="inner">
                    <span className="close" onClick={this.closeModal}></span>
                    <h3>Tilmelding til nyhedsbrev</h3>
                    <p className="newsletterText">Bliv opdateret med seneste nyt om udbudsret og få information om vores aktiviteter og invitationer til faglige arrangementer.</p>
                    <p dangerouslySetInnerHTML={{ __html: this.state.consent.text }}></p>
                    <NewsletterSignupForm
                        onSignUpSuccess={this.signupSuccess}
                        onValidForm={this.onValidEmailForm}
                        onInvalidForm={this.onInvalidEmailForm}
                        subscriptionIds={this.state.subscriptionIds}
                        consentId={this.state.consent.id}
                        formName='newsletter-modal'
                    />
                    {this.state.invalidEmailForm &&
                        <div className="message error">Der var en fejl i dit navn eller e-mail.</div>
                    }
                    {this.state.emailSend &&
                        <div className="message success">Tak for din tilmelding.</div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalNewsLetter.js